import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

import App from './App.vue'
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import VueI18n from 'vue-i18n'
import VueMeta from 'vue-meta'
import VueSlickCarousel from 'vue-slick-carousel'
import VueRecaptcha from 'vue-recaptcha'
import axios from 'axios'
import router from './router'
import store from './store'
import vnMessage from './lang/vn.json'
import vuetify from './plugins/vuetify'

// optional style for arrows & dots

Vue.prototype.$http = axios
const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

axios.defaults.baseURL = 'https://giftcode-backend.vgplay.vn/api'
// axios.defaults.baseURL = 'http://localhost/dev-giftcode.viga.mobi/public/api/'

Vue.use(VueMeta)

Vue.use(VueSlickCarousel)
Vue.use(VueRecaptcha)
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

Vue.use(VueI18n)

Vue.config.productionTip = false

const messages = {
  vn: vnMessage,
}
const i18n = new VueI18n({
  locale: 'vn', // set locale
  messages,
  fallbackLocale: 'vn',
})

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App),
}).$mount('#app')
